import { staticJSWUserBoardSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-jsw-userboard-sidebar/index.tsx';
import type { JiraUserBoardNavigationData } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/jsw-userboard-sidebar-navigation/types.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { UseJiraUserBoardNavigationResourceReturn } from './types.tsx';

export const useJiraUserBoardNavigationResource = (): UseJiraUserBoardNavigationResourceReturn =>
	useResource<JiraUserBoardNavigationData | null>(staticJSWUserBoardSidebarNavigationResource);
